module.exports = __webpack_public_path__ + "static/media/shantanu_benake.ba514bd2.png";